<template>
    <div>
        <!-- <div class="Notice" v-if="NoticeFlag == true">
            <div style="width:88%;margin:0 auto;">
                <van-notice-bar :left-icon="noticeIcon" @click="Noticeclick" @close="NoticeClose"
                    style="margin-top:4px;" mode="closeable"
                    background="linear-gradient(90deg, #E5FEFF 0%, #ECF1FD 100%)" color="rgba(0, 0, 0, 0.54)"
                    :text="description" />
            </div>
        </div> -->
        <main>
            <div v-if="NoticeFlag == true" style="width:100%;height:48px;"></div>
            <div class="banner">
                <!-- <div class="title">玖月琴侣课后陪练服务</div>
                <div class="name">电子键盘教师力推的课后陪练服务</div> -->
                <!-- <div class="bennerBackground">
                    <div class="bennerBackground_bottom">
                        <div style="width:100%;height:1px;margin-bottom:36px;">1</div>
                        <div class="title">玖月琴侣课后陪练服务</div>
                        <div class="name">
                            电子键盘教师力推的课后陪练服务
                        </div>
                        <div class="bannerCode">
                            <img src="../assets/joy.png" style="width:100%;" alt="">
                        </div>
                    </div>
                </div> -->
                <div>
                    <img src="http://banner.joymido.com/e0739095bc4409330cb015a1b31cd2a4" style="width:100%;" alt="">
                </div>
            </div>

            <div class="Why">
                <div class="title">为什么选择</div>
                <div class="name">玖月琴侣课后陪练服务？</div>
                <div class="explain">丰富科学的陪练产品和功能让学琴变得更快乐</div>
                <div class="swipe">
                    <van-swipe indicator-color="#FED847" initial-swipe="1" :autoplay="3000">
                        <van-swipe-item v-for="(item, index) in images" :key="index">
                            <img style="width:100%;border-radius:4px;" v-lazy="item.url" />
                            <div class="swipeName">
                                <div class="one">{{ item.name }}</div>
                                <div class="two">{{ item.title }}</div>
                            </div>
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
            <div class="afterClass">
                <div class="title">课后练习</div>
                <div class="name">过程不再困难</div>
                <div class="explain">AI智能陪练系统帮助孩子高效练琴提升自信</div>
                <div class="tab">
                    <van-row>
                        <van-col v-for="(item, index) in processData" :key="index" span="8">
                            <div class="tabButton" :style="processClickNum == index ? SelectStyle : UncheckedStyle"
                                @click="processClick(item, index)">
                                <van-icon class="icon" size="32px"
                                    :name="processClickNum == index ? item.icon_onclick : item.icon_onblur" />
                                <div class="tabName"
                                    :style="processClickNum == index ? 'color:#000000' : 'color: rgba(0, 0, 0, 0.38)'">
                                    {{ item.title }}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="img">
                    <van-image width="100%" radius="4px" :src="processImg" />
                </div>
                <div class="text">{{ processName }}</div>
            </div>
            <div class="afterClass" style="background:#fff">
                <div class="title">课后练习</div>
                <div class="name">结果高效清晰</div>
                <div class="explain">寓教于乐数据驱动让孩子每次练习都有结果</div>
                <div class="tab">
                    <van-row>
                        <van-col v-for="(item, index) in resultData" :key="index" span="8">
                            <div class="tabButton" :style="resultClickNum == index ? SelectStyle : resultUncheckedStyle"
                                @click="resultClick(item, index)">
                                <van-icon class="icon" size="32px"
                                    :name="resultClickNum == index ? item.icon_onclick : item.icon_onblur" />
                                <div class="tabName"
                                    :style="resultClickNum == index ? 'color:#000000' : 'color: rgba(0, 0, 0, 0.38)'">
                                    {{ item.title }}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="img">
                    <van-image width="100%" radius="4px" :src="resultImg" />
                </div>
                <div class="text">{{ resultName }}</div>
            </div>

            <div class="horseRaceLamp">
                <div class="name">从启蒙到十级</div>
                <div class="explain">提供超400本、20000首智能化曲谱</div>
                <div class="run">
                    <section class="picTab">
                        <ul class="ul1">
                            <li v-for="(item, index) in imgData">
                                <van-image width="100%" height="100%" radius="4px;" :src="item" />
                                {{ index }}
                            </li>
                        </ul>
                    </section>
                    <section class="picTab">
                        <ul class="ul2">
                            <li v-for="(item, index) in imgData2">
                                <van-image width="100%" height="100%" radius="4px;" :src="item" />
                                {{ index }}
                            </li>
                        </ul>
                    </section>
                    <section class="picTab">
                        <ul class="ul3">
                            <li v-for="(item, index) in imgData3">
                                <van-image width="100%" height="100%" radius="4px;" :src="item" />
                                {{ index }}
                            </li>
                        </ul>
                    </section>
                </div>
            </div>
            <!-- 为教学研发 -->
            <!-- <div class="study">
                <div class="name">专为教学研发</div>
                <div class="explain">汇总数千位钢琴教师建议的智能教学工具</div>
                <div class="CloudCoaching">
                    <div class="CloudCoaching_right">
                        <div class="fontWight">云辅导</div>
                        <div class="color">把老师带回家</div>
                        <div class="color">课后作业由教师布置并在线辅导</div>
                        <div class="color">课堂课后高效无缝衔接</div>
                    </div>
                </div>
                <van-image
                    width="100%"
                    radius="4px"
                    style="margin-top:24px;"
                    src="http://banner.joymido.com/CloudCoaching.png"
                />
                <div class="CloudCoaching">
                    <div class="CloudCoaching_left">
                        <div class="fontWight">云课堂</div>
                        <div class="color">把教室带回家</div>
                        <div class="color">100%还原线下授课场景</div>
                        <div class="color">全方位解决无法线下授课的问题</div>
                    </div>
                </div>
                <van-image
                    width="100%"
                    radius="4px"
                    style="margin-top:24px;"
                    src="http://banner.joymido.com/CloudClassroom1.png"
                />
                <div class="Tips">
                    温馨提示:</br>云课堂/云辅导功能需向机构或教师申请通过后方能使用。
                </div>
            </div> -->

            <div class="honor">
                <div class="titleStyle">品牌荣誉</div>
                <div class="honorCenter">
                    <div class="li" v-for="(item, index) in honorData" :key="index">
                        <van-image width="100%" height="164px" :src="item.url" />
                        <div class="title">{{ item.title }}</div>
                        <p class="contentWord">{{ item.note }}</p>
                    </div>
                </div>
            </div>

            <div class="evaluate">
                <div class="titleStyle">用户评价</div>
                <div class="evaluate_img">
                    <div style="width:49%;margin-top:2px;" v-for="(item, index) in UserEvaluationData" :key="index">
                        <van-image @click="imgClick(index)" width="100%" radius="4px" class="van_image" :src="item" />
                    </div>
                </div>
            </div>
            <!-- 合作加盟 -->
            <div class="JoinIn">
                <div class="titleStyle">合作加盟</div>
                <div class="agent">玖月琴侣全国代理商&合作机构火热招商中</div>
                <div class="number">
                    <div class="num">
                        <div class="left">30</div>
                        <div class="right">+</div>
                    </div>
                    <div class="explain">覆盖全国省份</div>
                </div>
                <div class="number">
                    <div class="num">
                        <div class="left">200</div>
                        <div class="right">+</div>
                    </div>
                    <div class="explain">覆盖城市</div>
                </div>
                <div class="number">
                    <div class="num">
                        <div class="left">900</div>
                        <div class="right">+</div>
                    </div>
                    <div class="explain">授权合作机构</div>
                </div>

                <div class="source">数据来源：玖月琴侣后台大数据统计 （数据截止2025年7月28日）</div>
                <div class="cooperation" @click="cooperationClick">我要合作</div>
            </div>
            <!-- 联系我们 -->
            <div class="contactUs">
                <div class="titleStyle">联系我们</div>
                <div class="code">
                    <van-image width="49%" radius="4px" :src='klbmImg' />
                    <van-image width="49%" radius="4px" :src="miniImg" />
                </div>
                <div class="content">
                    <div class="left">
                        <van-image width="20px" height="18px" style="margin-top:2px;" :src='cooperationIcon' />
                    </div>
                    <div class="right">
                        <div class="title">商务合作：</div>
                        <div class="title name"><span>jiuyueqinlv@163.com</span></div>
                    </div>
                </div>
                <div class="content">
                    <div class="left">
                        <van-image width="20px" height="18px" style="margin-top:2px;" :src='addressIcon' />
                    </div>
                    <div class="right">
                        <div class="title">公司地址</div>
                        <div class="title name">北京市朝阳区高碑店乡西店记忆F3-F108玖月音乐</div>
                    </div>
                </div>
                <div class="content">
                    <div class="left">
                        <van-image width="20px" height="18px" style="margin-top:2px;" :src='phoneIcon' />
                    </div>
                    <div class="right">
                        <div class="title">全国24小时统一热线：</div>
                        <div class="title name">19264192748</div>
                    </div>
                </div>
            </div>

            <div class="footer">
                <!-- <div class="one">Copyright © 2013-2021 大连佳音科技有限公司版权所有（京ICP备2025137204号）</div> -->
                <div class="two">
                    <van-icon size="12" :name="policeBadgeIcon" />
                    <div>京ICP备2025137204号</div>
                </div>
            </div>
            <!-- <div v-if="scrollFlag == true" style="width:100%;height:104px;"></div> -->
        </main>
        <!-- <div class="DownloadNow"  :class="{DownloadNowHide:DownloadNowHideFlag}"> -->
        <div class="DownloadNow" :style="scrollFlag == true ? DownloadNow : DownloadNowHide">
            <div class="width">
                <div style="display: flex;justify-content: space-between;">
                    <img width="48px" height="48px" radius="4px" style="margin-right:4px;"
                        src='../assets/logo_img.png' />
                    <div>
                        <div class="name">玖月琴侣</div>
                        <div style="font-size: 12px;color:rgba(0, 0, 0, 0.32);">
                            钢琴教师力推的课后陪练服务
                        </div>
                    </div>
                </div>
                <div class="DownloadBtn" @click="downloadClick">立即下载</div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { NoticeBar, Image as VanImage, Swipe, SwipeItem, Lazyload, Grid, GridItem, Col, Row, Icon, ImagePreview } from 'vant';
Vue.use(NoticeBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(Icon);
Vue.use(VanImage);
Vue.use(ImagePreview);

export default {
    name: 'yd',
    conponents: {
        VanImage,
        NoticeBar
    },
    data() {
        return {
            processImg: '',
            processName: '',
            resultImg: '',
            resultName: '',
            NoticeFlag: true,
            processClickNum: 0,
            resultClickNum: 0,
            noticeIcon: require('../assets/web_mobile_tips.png'),

            klbmImg: 'http://banner.joymido.com/581f3fdfcb94d87e1262d1dba856aa62',
            // miniImg: 'http://banner.joymido.com/ea3b9f4485f0045d94adc4a50ae4dd90',
            miniImg: require('../assets/kefu_img.png'),
            cooperationIcon: require('../assets/web_mobile_us_icon03.png'),
            addressIcon: require('../assets/web_mobile_us_icon02.png'),
            phoneIcon: require('../assets/web_mobile_us_icon01.png'),
            policeBadgeIcon: require('../assets/policeBadge.png'),
            // initiationImg:require('../assets/web_mobile_paomadeng.png'),

            SelectStyle: 'background: #FED847',
            UncheckedStyle: 'background: #f4f4f4',
            resultUncheckedStyle: 'background: #fff',
            processData: [

            ],
            resultData: [
                {
                    url: 'http://banner.joymido.com/web_mobile_tab_img06.png',
                    name: '专为激发孩子学习兴趣研发了评星系统和语音系统，让孩子练习更有乐趣。'
                },
                {
                    url: 'http://banner.joymido.com/web_mobile_tab_img04.png',
                    name: '定制孩子的练习目标，选择符合课后练习重点的陪练模式，杜绝无效练习。'
                }, {
                    url: 'http://banner.joymido.com/web_mobile_tab_img05.png',
                    name: '练习结果每周一报，横向比对孩子练习数据，学习成果练习方向了然于胸。'
                },
            ],
            // 轮播数组
            images: [
                { url: 'http://banner.joymido.com/f5bd7a71a830f9f2fb471c8b8e2536fc', name: "孩子更快乐的练琴", title: "多样的激励功能让每一次弹奏都有收获感" },
                { url: 'http://banner.joymido.com/185c450bda860ccaec1f550bc35a189f', name: "家长更快乐的陪伴", title: "清晰的陪练功能让陪练变得既开心又融洽" },
                { url: 'http://banner.joymido.com/44436bbb624bcc25a6bd4a4bc3cf99fb', name: "教师更快乐的授课", title: "高效的练习成果让教师回课效率大大提高" },
            ],
            // 荣誉数组
            honorData: [
                //0728修改
                {
                    url: "http://banner.joymido.com/0f346bba5a879ebea48c561ff5bacb85",
                    title: '『荣获国家高新技术企业荣誉』',
                },
                {
                    url: "http://banner.joymido.com/1aeb2f1f4b4b6ef5d5f90b7315377326",
                    title: '『多项产品发明专利及软件著作权』',
                },
                // {
                //     url: "http://banner.joymido.com/web_mobile_honor01.png",
                //     title: "『音乐教育科技产业园正式授牌』",
                //     msg: '上音佳音携手，沪连合作迈向新阶段 音乐科技融合，互联资源拓展新业态'
                // },
                // {
                //     url: "http://banner.joymido.com/web_mobile_honor02.png",
                //     title: "『发明创业奖·项目奖』",
                //     msg: '荣获2016年第九届国际发明展览会 "发明创业奖·项目奖"一金一银一铜三项大奖'
                // },
                // {
                //     url: "http://banner.joymido.com/web_mobile_honor04.png",
                //     title: "『音乐社会教育远程培训中心授牌』",
                //     msg: '造互联教育新业态 谱写沪连合作新乐章'
                // },
                // {
                //     url: "http://banner.joymido.com/web_mobile_honor05.png",
                //     title: "『权威机构推荐』",
                //     msg: '中央音乐学院、中国音乐学院等高等院校推荐的指定钢琴课后陪练服务。'
                // },
                // {
                //     url: "http://banner.joymido.com/web_mobile_honor06.png",
                //     title: "『中国设计红星奖·最受大众喜爱奖』",
                //     msg: '荣膺2016年"中国设计红星奖"、 "中国设计红星奖·最受大众喜爱奖"两项殊荣'
                // },
                // {
                //     url: "http://banner.joymido.com/web_mobile_honor07.png",
                //     title: "『多项知识产权』",
                //     msg: '项目所囊括的全部系列产品已斩获众多专业领域知识产权和荣誉'
                // },
            ],
            // 评价数组
            UserEvaluationData: [
                'http://banner.joymido.com/c91b743ccc57cde97b2b507e3f9751ed',
                'http://banner.joymido.com/UserEvaluation02.png',
                'http://banner.joymido.com/UserEvaluation03.png',
                'http://banner.joymido.com/UserEvaluation04.png',
                'http://banner.joymido.com/UserEvaluation05.png',
                'http://banner.joymido.com/UserEvaluation06.png',
                'http://banner.joymido.com/UserEvaluation07.png',
                'http://banner.joymido.com/UserEvaluation08.png',
                // 'http://banner.joymido.com/UserEvaluation09.png',
                // 'http://banner.joymido.com/UserEvaluation10.png',
                // 'http://banner.joymido.com/UserEvaluation11.png',
                // 'http://banner.joymido.com/UserEvaluation12.png',
            ],
            scroll: '',
            scrollNum: 0,
            scrollFlag: true,
            DownloadNowHide: 'transition: all 200ms;bottom:-200px',
            DownloadNow: 'transition: all 200ms;bottom:0',

            // 从启蒙到十级数据
            imgData: [],
            imgData2: [],
            imgData3: [],

            description: '',//通知栏数据
        }
    },
    mounted() {
        window.addEventListener('scroll', this.menu)
        var timer = setInterval(() => {
            if (this.scrollNum == this.scroll) {
                this.scrollFlag = true
            } else {
                this.scrollNum = this.scroll
            }
        }, 3000);
        this.pmd()
        // this.resultClick(1)
        // this.processClick(1)
        this.website_notice()
        this.website_mobile_tab_img()
        this.website_mobile_tab_img_result()
        // this.website_rongyu()
        this.website_pj()
    },
    methods: {
        cooperationClick() {
            this.$router.push('/cooperation')
        },
        website_pj() {
            this.$http.get('/website/type/website_pj').then(res => {
                let data = []
                for (let i = 0; i < 8; i++) {
                    let JSONData = JSON.parse(res.data.data[i].description).url
                    data.push(JSONData)
                }
                this.UserEvaluationData = data
                console.log(data)
            })
        },
        website_rongyu() {
            this.$http.get('/website/type/website_rongyu').then(res => {
                let data = []
                for (let i = 0; i < res.data.data.length; i++) {
                    let JSONData = JSON.parse(res.data.data[i].description)
                    data.push(JSONData)
                }
                this.honorData = data
            })
        },
        website_mobile_tab_img_result() {
            this.$http.get('/website/type/website_mobile_tab_img_result').then(res => {
                let data = []
                for (let i = 0; i < res.data.data.length; i++) {
                    let JSONData = JSON.parse(res.data.data[i].description)
                    data.push(JSONData)
                }
                this.resultImg = data[0].url
                this.resultName = data[0].note
                this.resultData = data
            })
        },
        website_mobile_tab_img() {
            this.$http.get('/website/type/website_mobile_tab_img').then(res => {
                let data = []
                for (let i = 0; i < res.data.data.length; i++) {
                    let JSONData = JSON.parse(res.data.data[i].description)
                    data.push(JSONData)
                }
                this.processImg = data[0].url
                this.processName = data[0].note
                this.processData = data
            })
        },
        website_notice() {
            this.$http.get('/website/type/website_notice').then(res => {
                this.description = res.data.data[0].description
            })
        },
        Noticeclick() {
            this.$router.push({ path: '/DeclarationLetter' })
        },
        pmd() {
            let imgData = []
            let concatArr = []
            let imgData2 = []
            let concatArr2 = []
            let imgData3 = []
            let concatArr3 = []
            for (var i = 0; i < 40; i++) {
                let url = 'https://cover.img.joymido.com/M_' + Math.ceil(Math.random() * 95) + '.jpg'
                let url2 = 'https://cover.img.joymido.com/M_' + Math.ceil(Math.random() * 95) + '.jpg'
                let url3 = 'https://cover.img.joymido.com/M_' + Math.ceil(Math.random() * 95) + '.jpg'
                imgData.push(url)
                concatArr.push(url)
                imgData2.push(url2)
                concatArr2.push(url2)
                imgData3.push(url3)
                concatArr3.push(url3)
            }
            this.imgData = imgData.concat(concatArr)
            this.imgData2 = imgData2.concat(concatArr2)
            this.imgData3 = imgData3.concat(concatArr3)
        },
        handleScroll() {
            window.addEventListener('scroll', () => {
                this.scrollTop = window.scrollY;
            })
        },
        NoticeClose() {
            this.NoticeFlag = false
        },
        processClick(item, index) {
            console.log(item)
            this.processClickNum = index
            this.processImg = item.url
            this.processName = item.note
        },
        resultClick(item, index) {
            this.resultClickNum = index
            this.resultImg = item.url
            this.resultName = item.note

        },
        imgClick(index) {
            ImagePreview({
                images: this.UserEvaluationData,
                startPosition: index,
            });
        },
        downloadClick() {
            window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.mohe.happyzebra"
        },
        menu() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop
            let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
            // console.log(scroll)
            // console.log(scrollHeight)
            if (scroll == scrollHeight) {
                this.scrollFlag = true
                this.DownloadNowHideFlag = false
            } else {
                if (this.scroll > scroll) {
                    this.scrollFlag = true
                    this.DownloadNowHideFlag = false
                } else {
                    this.scrollFlag = false
                    this.DownloadNowHideFlag = true
                }
            }

            this.scroll = scroll;
        }
    }
}
</script>
<style lang="scss" scoped>
* {
    padding: 0;
    margin: 0;
}

.Notice {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    background: tan;
    background: linear-gradient(90deg, #E5FEFF 0%, #ECF1FD 100%);
    z-index: 999;
}

.color {
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
    color: #000000;
}

.fontWight {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    text-transform: capitalize;
    color: #000000;
}

.titleStyle {
    width: 99px;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    text-transform: capitalize;
    color: #000000;
    margin: 0 auto;
    background: url('../assets/web_mobile_line.png') no-repeat;
    background-size: 100%;
    background-position: bottom;
    font-weight: 600;
}

.banner {
    // height: 392px;
    position: relative;

    // padding-top: 36px;
    // background: url('../assets/web_mobile_top_img.png');
    // background-size:100%;
    // background-position:bottom;
    // .bennerBackground{
    //     background: url('../assets/web_mobile_top_img01.png') no-repeat; 
    //     background-size:400%;
    //     background-position:center;
    //     height: 392px;
    // }
    // .bennerBackground_bottom{
    //     background: url('../assets/web_mobile_top_dangban.png') no-repeat; 
    //     background-size:100%;
    //     background-position:bottom;
    //     height: 342px;
    // }
    .title {
        text-align: center;
        font-family: OPPOSans;
        font-size: 32px;
        line-height: 30px;
        color: #875D18;
        text-transform: capitalize;
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        top: 8%;
    }

    .name {
        width: 320px;
        margin: 0 auto;
        // padding:0 20px;
        background: #875D18;
        font-size: 22px;
        text-align: center;
        height: 45px;
        line-height: 45px;
        border-radius: 100px;
        color: #FFD55C;
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        top: 21% // left:6%;
    }

    .bannerCode {
        width: 308px;
        height: 42px;
        margin: 0 auto;
        margin-top: -10px;
        z-index: 98;
        // position: absolute;
        // left:8%;
        top: 130px;
    }
}

.Why {
    margin-top: 48px;

    .title {
        text-align: center;
        font-size: 28px;
        line-height: 37px;
        text-transform: capitalize;
        color: #000000;
        font-weight: 600;
    }

    .name {
        font-family: OPPOSans;
        font-size: 28px;
        line-height: 37px;
        text-align: center;
        // display: inline-block;
        text-transform: capitalize;
        color: #1584FC;
        font-weight: 600;
        background-image: linear-gradient(90deg, #FF6543, #EE43BE, #1B5BFF, #0094FF, #32E2E2);
        box-sizing: border-box;
        // background-image: -webkit-linear-gradient(200.41deg, #32E2E2 0.84%, #0094FF  24.8%, #1B5BFF 51.37%, #EE43BE 74.81%, #FF6543 100.85%);
        // background: linear-gradient(to right, red, blue);
        -webkit-background-clip: text;
        color: transparent;
    }

    .explain {
        text-align: center;
        font-size: 16px;
        line-height: 21px;
        text-align: center;
        text-transform: capitalize;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 200;
    }

    .swipe {
        width: 88%;
        // height: 185px;
        // background: tan;
        margin: 0 auto;
        margin-top: 48px;
        border-radius: 4px;
        overflow: hidden;

        .swipeName {
            position: absolute;
            width: 100%;
            height: 73px;
            bottom: 4px;
            border-radius: 0 0 4px 4px;
            background: rgba(0, 0, 0, 0.54);

            .one {
                font-weight: 600;
                margin-top: 8px;
                font-size: 16px;
                line-height: 21px;
                text-align: center;
                text-transform: capitalize;
                color: #FFFFFF;
            }

            .two {
                font-family: OPPOSans;
                font-size: 12px;
                margin-top: 4px;
                line-height: 16px;
                text-align: center;
                color: #FFFFFF;

            }
        }
    }
}

.afterClass {
    background: #f4f4f4;
    margin-top: 24px;
    padding-top: 48px;
    padding-bottom: 48px;

    .title {
        text-align: center;
        font-size: 28px;
        line-height: 37px;
        text-transform: capitalize;
        color: #000000;
        font-weight: 600;
    }

    .name {
        font-size: 28px;
        line-height: 37px;
        text-align: center;
        // display: inline-block;
        text-transform: capitalize;
        color: #1584FC;
        font-weight: 600;
        background-image: linear-gradient(90deg, #FF6543, #EE43BE, #1B5BFF, #0094FF, #32E2E2);
        box-sizing: border-box;
        // background-image: -webkit-linear-gradient(200.41deg, #32E2E2 0.84%, #0094FF  24.8%, #1B5BFF 51.37%, #EE43BE 74.81%, #FF6543 100.85%);
        // background: linear-gradient(to right, red, blue);
        -webkit-background-clip: text;
        color: transparent;
    }

    .explain {
        text-align: center;
        font-size: 16px;
        line-height: 21px;
        text-align: center;
        text-transform: capitalize;
        margin-top: 16px;
        font-weight: 200;
        color: rgba(0, 0, 0, 0.54);
    }

    .tab {
        width: 88%;
        margin: 0 auto;
        margin-top: 48px;

        .tabButton {
            width: 100%;
            height: 93px;
            text-align: center;
            border-radius: 4px;

            .icon {
                margin-top: 18px;
            }

            .tabName {
                font-size: 16px;
                line-height: 21px;
                align-items: center;
                text-transform: capitalize;
                // color: #000000;
            }
        }
    }

    .img {
        width: 88%;
        // background: tan;
        margin: 0 auto;
        margin-top: 24px;
    }

    .text {
        width: 88%;
        margin: 0 auto;
        margin-top: 24px;
        font-family: OPPOSans;
        font-size: 16px;
        line-height: 21px;
        text-transform: capitalize;
        color: #000000;
    }
}

.horseRaceLamp {
    width: 100%;
    padding: 48px 0;
    background: #f4f4f4;

    .name {
        font-size: 28px;
        line-height: 37px;
        text-align: center;
        font-weight: 600;
        background-image: linear-gradient(90deg, #FF6543, #EE43BE, #1B5BFF, #0094FF, #32E2E2);
        box-sizing: border-box;
        -webkit-background-clip: text;
        color: transparent;
    }

    .explain {
        text-align: center;
        font-size: 16px;
        line-height: 21px;
        text-align: center;
        text-transform: capitalize;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 200;
    }

    .run {
        margin-top: 48px;

        @keyframes move {
            0% {
                transform: translateX(0px);
            }

            // 15% {transform:translateX(-200px); } 
            // 30% {transform:translateX(-400px); } 
            // 45% {transform:translateX(-600px); } 
            // 60% {transform:translateX(-800px); } 
            // 75% {transform:translateX(-1000px); } 
            // 90% {transform:translateX(-1200px); } 
            100% {
                transform: translateX(-2920px)
            }
        }

        // ul{margin:0;padding:0; list-style:none;} 
        .picTab {
            width: 100%;
            height: 84px;
            margin: 8px auto;
            overflow: hidden;
        }

        .picTab ul {
            width: 8000px;
            height: 84px;
        }

        .picTab li {
            float: left;
            width: 65px;
            height: 84px;
            margin: 0 4px;
            font: 50px/98px "宋体";
            text-align: center;
            border-radius: 4px;
            overflow: hidden;
        }

        .ul1 {
            animation: move 75s linear infinite;
        }

        .ul2 {
            animation: move 60s linear infinite;
        }

        .ul3 {
            animation: move 75s linear infinite;
        }
    }

}

.study {
    width: 100%;
    // height: 1050px;
    padding: 48px 0;
    background: url('../assets/background.png') no-repeat;
    background-size: 100%;
    background-position: bottom;

    // background: tan;
    .name {
        font-size: 28px;
        line-height: 37px;
        text-align: center;
        text-transform: capitalize;
        color: #1584FC;
        font-weight: 600;
        background-image: linear-gradient(90deg, #FF6543, #EE43BE, #1B5BFF, #0094FF, #32E2E2);
        box-sizing: border-box;
        -webkit-background-clip: text;
        color: transparent;
    }

    .explain {
        text-align: center;
        font-family: OPPOSans;
        font-size: 16px;
        line-height: 21px;
        text-align: center;
        text-transform: capitalize;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.54);
    }

    .CloudCoaching {
        width: 88%;
        margin: 0 auto;
        height: 103px;
        margin-top: 48px;

        .CloudCoaching_right {
            height: 100%;
            border-right: 3px solid #FED847;
            padding-top: 2px;
            text-align: right;
            padding-right: 16px;
        }

        .CloudCoaching_left {
            height: 100%;
            margin-top: 48px;
            border-left: 3px solid #FED847;
            padding-top: 2px;
            padding-left: 16px;
        }
    }

    .Tips {
        width: 88%;
        margin: 0 auto;
        // height: 103px;
        font-size: 13px;
        line-height: 20px;
        text-transform: capitalize;
        color: rgba(0, 0, 0, 0.54);
    }
}

.honor {
    width: 100%;
    background: #f4f4f4;
    padding: 48px 0;
    padding-bottom: 8px;
    overflow: hidden;

    .honorCenter::-webkit-scrollbar {
        display: none;
    }

    .honorCenter {
        width: 94%;
        float: right;
        height: 300px;
        margin-top: 26px;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        // overflow-x:visible;
        background: #f4f4f4;

        // box-shadow: 0px 4px 8px rgba(12, 0, 51, 0.1);
        .li {
            width: 300px;
            height: 268px;
            background: #fff;
            display: inline-block;
            margin-right: 24px;
            border-radius: 4px;
            overflow: hidden;
            box-shadow: 0px 8px 16px rgba(12, 0, 51, 0.1);

            .title {
                width: 92%;
                margin: 0 auto;
                font-weight: bold;
                font-size: 17px;
                line-height: 44px;
                text-align: center;
                text-transform: capitalize;
                color: #000000;
            }

            .contentWord {
                width: 92%;
                margin: 0 auto;
                white-space: pre-wrap;
                word-break: break-all;
                word-break: break-word;
                text-align: center;
                font-family: OPPOSans;
                font-size: 14px;
                line-height: 20px;
                color: rgba(0, 0, 0, 0.54);
            }
        }
    }
}

.evaluate {
    padding: 48px 0;
    // background: #fff;
    width: 100%;

    .evaluate_img {
        width: 88%;
        margin: 0 auto;
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .van_image {
            border: 1px solid rgba(0, 0, 0, 0.06);
            box-shadow: 0px 8px 16px rgba(12, 0, 51, 0.1);
        }
    }
}

.JoinIn {
    width: 100%;
    // height:720px ;
    padding: 48px 0;
    background: url('http://banner.joymido.com/web_mobile_bj02.png') no-repeat;
    background-size: 650%;
    background-position: top;

    .agent {
        margin-top: 24px;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        text-transform: capitalize;
        color: rgba(0, 0, 0, 0.54);
    }

    .number {
        width: 74%;
        margin: 0 auto;
        height: 85px;
        margin-top: 24px;
        border-left: 3px solid #FA5151;
        padding-left: 16px;

        .num {
            overflow: hidden;

            .left {
                font-weight: bold;
                font-size: 48px;
                // line-height: 63px;
                text-transform: capitalize;
                color: #FB554E;
                float: left;
                vertical-align: middle;
            }

            .right {
                font-weight: bold;
                font-size: 17px;
                float: left;
                margin-left: 12px;
                line-height: 60px;
                text-transform: capitalize;
                color: #FB554E;
                vertical-align: middle;
            }
        }

        .explain {
            font-size: 16px;
            line-height: 22px;
            text-transform: capitalize;
            color: rgba(0, 0, 0, 0.54);
        }
    }

    .source {
        width: 230px;
        margin: 0 auto;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        text-transform: capitalize;
        color: rgba(0, 0, 0, 0.32);
        margin-top: 48px;
    }

    .cooperation {
        width: 88%;
        height: 56px;
        background: #FB554E;
        border-radius: 4px;
        margin: 0 auto;
        text-align: center;
        line-height: 56px;
        margin-top: 24px;
        font-size: 17px;
        color: #fff;
        font-family: OPPOSans;
        font-style: normal;
        font-weight: bold;
    }
}

.contactUs {
    padding: 48px 0;

    .code {
        width: 88%;
        margin: 0 auto;
        margin-top: 24px;
        display: flex;
        justify-content: space-between
    }

    .content {
        width: 88%;
        margin: 0 auto;
        margin-top: 24px;
        overflow: hidden;

        .left {
            float: left;
            width: 30px;
        }

        .right {
            float: left;
            width: 260px;

            .title {
                font-size: 17px;
                line-height: 24px;
                text-transform: capitalize;
                color: rgba(0, 0, 0, 0.54);
            }

            .name {
                color: #000000;
                font-weight: bold;
            }
        }
    }
}

.footer {
    padding: 24px;
    background: #404040;

    .one {
        width: 88%;
        margin: 0 auto;
        text-align: center;
        font-size: 14px;
        line-height: 20px;
        color: #FFFFFF;
    }

    .two {
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        justify-content: center;
        align-items: center;
        text-transform: capitalize;
        color: #FFFFFF;
        display: flex;
        margin-top: 16px;
    }
}

@keyframes mymove {
    from {
        bottom: -104px;
    }

    /*执行动画的初始位置*/
    to {
        bottom: 0px;
    }

    /*动画结束位置*/
    0% {
        opacity: 1;
        /*初始状态 透明度为10%*/
    }

    50% {
        opacity: 1;
        /*中间状态 透明度为50%*/
    }

    100% {
        opacity: 1;
        /*结尾状态 不透明*/
    }
}

.DownloadNowHide {
    transition: all 0.2s;
    bottom: -200px
}

.DownloadNow {
    width: 100%;
    height: 104px;
    animation-name: mymove;
    animation-duration: 300ms;
    /* 兼容调试如果animation-name执行，那么-wekit-animation-name则不执行 */
    -webkit-animation-name: mymove;
    -webkit-animation-duration: 300ms;
    background: #fff;
    position: fixed;
    bottom: -200;
    left: 0;
    box-shadow: inset 0px 0.5px 0px rgba(0, 0, 0, 0.12);

    .width {
        width: 88%;
        height: 48px;
        margin: 0 auto;
        margin-top: 28px;
        display: flex;
        justify-content: space-between;

        .name {
            font-size: 20px;
            line-height: 30px;
            font-weight: bold;
            text-transform: capitalize;
            color: #000000;
        }

        .DownloadBtn {
            width: 107px;
            height: 38px;
            background: #FED847;
            border-radius: 100px;
            text-align: center;
            line-height: 38px;
            margin-top: 5px;
            font-size: 16px;
            font-weight: bold;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/indexYd.vue